import { Link } from '~/components/ui/link'

export const BlogCTA = () => {
  return (
    <div className=''>
      <div className='mx-auto max-w-7xl pt-16 sm:px-6 lg:px-8'>
        <div className='relative isolate overflow-hidden bg-[radial-gradient(ellipse_at_bottom_right,var(--tw-gradient-stops))] from-rose-400 via-fuchsia-500 to-indigo-500 px-6 py-24 text-center shadow-2xl sm:rounded-3xl sm:px-16'>
          <h2 className='mx-auto max-w-2xl font-bold text-3xl text-white tracking-tight sm:text-4xl'>
            타입잇, 지금 시작하세요!
          </h2>
          <p className='mx-auto mt-6 max-w-xl text-lg text-white leading-8 opacity-90'>
            막막한 글쓰기, 나만의 AI 카피라이터 타입잇과 함께라면 두렵지 않습니다.
          </p>
          <div className='mt-10 flex items-center justify-center gap-x-6'>
            <Link
              href='/app'
              className='rounded-md bg-white px-3.5 py-2.5 font-semibold text-gray-900 text-sm shadow-xs hover:bg-gray-100 focus-visible:outline-2 focus-visible:outline-solid focus-visible:outline-white focus-visible:outline-offset-2'
            >
              지금 시작하기
            </Link>
            <Link href='/blog' className='font-semibold text-sm text-white leading-6'>
              블로그 더 보기 <span aria-hidden='true'>→</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export const BackgroundCloud = () => (
  <svg
    viewBox='0 0 801 1036'
    aria-hidden='true'
    className='absolute -top-80 left-[max(6rem,33%)] -z-10 w-200.25 transform-gpu blur-3xl sm:left-1/2 md:top-20 lg:ml-20 xl:top-3 xl:ml-56'
  >
    <path
      fill='url(#bba7d695-d9bb-4e8a-a43b-2b951b4ac9c0)'
      fillOpacity='.3'
      d='m282.279 843.371 32.285 192.609-313.61-25.32 281.325-167.289-58.145-346.888c94.5 92.653 277.002 213.246 251.009-45.597C442.651 127.331 248.072 10.369 449.268.891c160.956-7.583 301.235 116.434 351.256 179.39L507.001 307.557l270.983 241.04-495.705 294.774Z'
    />
    <defs>
      <linearGradient
        id='bba7d695-d9bb-4e8a-a43b-2b951b4ac9c0'
        x1='508.179'
        x2='-28.677'
        y1='-116.221'
        y2='1091.63'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#9089FC' />
        <stop offset={1} stopColor='#FF80B5' />
      </linearGradient>
    </defs>
  </svg>
)

export const BackgroundGrid = () => (
  <svg
    className='mask-[radial-gradient(64rem_64rem_at_111.5rem_0%,white,transparent)] absolute -top-160 left-1 -z-10 h-256 w-702 -translate-x-1/2 stroke-gray-900/10'
    aria-hidden='true'
  >
    <defs>
      <pattern id='e87443c8-56e4-4c20-9111-55b82fa704e3' width={200} height={200} patternUnits='userSpaceOnUse'>
        <path d='M0.5 0V200M200 0.5L0 0.499983' />
      </pattern>
    </defs>
    <rect width='100%' height='100%' strokeWidth={0} fill='url(#e87443c8-56e4-4c20-9111-55b82fa704e3)' />
  </svg>
)
